var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#006286",
    fill: "#FFF",
    x: -0.5,
    y: -0.5,
    width: 21,
    height: 21,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 11.077h-4.123V15.2H9.723v-4.123H5.6V9.723h4.123V5.6h1.354v4.123H15.2z",
    fill: "#006286",
    fillRule: "nonzero"
  }))));
}
export default SvgAdd;